module.exports = __webpack_public_path__ + "static/media/bannerayuda.3dfb8ac9.jpg";